export function useAppEnv() {
  const appEnv = useRuntimeConfig().public.appEnv
  return { appEnv, isTesting: appEnv === 'testing' }
}
